if (!customElements.get('fablair-media-collection')) {
  customElements.define('fablair-media-collection', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.tabs = [...this.querySelectorAll('[data-fmc-tab]')];
      this.panels = [...this.querySelectorAll('[data-fmc-panel]')];
      const navigation = this.querySelector('[data-fmc-tabs]');
      if (navigation && this.tabs.length > 1) {
        navigation.setAttribute('role', 'tablist');
        const syncOrientation = () => navigation.setAttribute('aria-orientation', navigation.dataset.orientation === 'vertical' && window.matchMedia('(min-width: 1100px)').matches ? 'vertical' : 'horizontal');
        syncOrientation();
        window.addEventListener('resize', syncOrientation, { signal, passive: true });
        this.tabs.forEach((tab, index) => {
          const panel = this.panels.find(item => item.dataset.fmcPanel === tab.dataset.fmcTab);
          if (!panel) return;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
          tab.addEventListener('click', event => {
            event.preventDefault();
            this.selectTab(index, false);
          }, { signal });
          tab.addEventListener('keydown', event => {
            const vertical = navigation.getAttribute('aria-orientation') === 'vertical';
            const rtl = getComputedStyle(navigation).direction === 'rtl';
            const forward = vertical ? 'ArrowDown' : rtl ? 'ArrowLeft' : 'ArrowRight';
            const backward = vertical ? 'ArrowUp' : rtl ? 'ArrowRight' : 'ArrowLeft';
            let next;
            if (event.key === forward) next = (index + 1) % this.tabs.length;
            else if (event.key === backward) next = (index + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key === ' ') next = index;
            if (next === undefined) return;
            event.preventDefault();
            this.selectTab(next, true);
          }, { signal });
        });
        this.selectTab(0, false);
        this.dataset.enhanced = '';
      }
      this.addEventListener('keydown', event => {
        if (event.key === 'Tab') this.dataset.keyboard = '';
      }, { signal });
      this.addEventListener('pointerdown', () => { delete this.dataset.keyboard; }, { signal, passive: true });
      this.querySelectorAll('.fablair-media-collection__products--rail').forEach(rail => {
        rail.tabIndex = 0;
        rail.setAttribute('role', 'region');
        rail.setAttribute('aria-label', 'Koleksiyon ürünleri');
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab.dataset.fmcTab === event.detail?.blockId);
        if (index !== -1) this.selectTab(index, false);
      }, { signal });
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const reduceMotion = () => {
        if (motion.matches) this.querySelectorAll('video[autoplay]').forEach(video => video.pause());
      };
      reduceMotion();
      motion.addEventListener('change', reduceMotion, { signal });
    }
    selectTab(index, focus) {
      const selected = this.tabs[index];
      if (!selected) return;
      this.tabs.forEach((tab, tabIndex) => {
        tab.setAttribute('aria-selected', String(tabIndex === index));
        tab.tabIndex = tabIndex === index ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.fmcPanel !== selected.dataset.fmcTab; });
      if (focus) selected.focus({ preventScroll: true });
    }
    disconnectedCallback() { this.abortController?.abort(); }
  });
}
